// 009 FR-045: the checkout just paid, in memory, for the confirmation screen (never on the device).
import type { Api } from "@/api/types";

let last: { checkout: Api["Checkout"]; address: string } | null = null;
export const lastCheckout = {
  set(checkout: Api["Checkout"], address: string) {
    last = { checkout, address };
  },
  get: () => last,
  clear() {
    last = null;
  },
};
